import React from 'react';
import { connect } from 'react-redux';

import type { User } from 'v2/interfaces/user';

import { Consultancy } from './components/Consultancy';
import ManagerInfo from './components/ManagerInfo';

import type { RouteComponentProps } from 'react-router-dom';

interface IProps extends RouteComponentProps {
  accountUser: User;
}

function AccountManager({ accountUser }: IProps | any) {
  const { account_manager } = accountUser;

  const managerInfoComponent = () => (account_manager?.isPublicManager ? <ManagerInfo data={accountUser.account_manager} /> : null);

  return <>{accountUser.account_manager_id === 792 ? <Consultancy user={accountUser} /> : managerInfoComponent()}</>;
}

function mapStateToPros(state: any) {
  return {
    accountUser: state.orbita.User.user.user,
  };
}

export default connect(mapStateToPros)(AccountManager);
